import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.421 6.74295L13.3255 5.83845C13.7085 5.45511 14.1632 5.15099 14.6638 4.94345C15.1643 4.73592 15.7008 4.62903 16.2427 4.62891C16.7846 4.62878 17.3211 4.73542 17.8218 4.94272C18.3224 5.15002 18.7773 5.45393 19.1605 5.83709C19.5436 6.22025 19.8475 6.67514 20.0548 7.17578C20.2621 7.67642 20.3688 8.213 20.3687 8.75487C20.3685 9.29673 20.2616 9.83326 20.0541 10.3338C19.8466 10.8344 19.5424 11.2891 19.1591 11.6721L16.32 14.5112C15.9369 14.8943 15.4822 15.1981 14.9817 15.4054C14.4812 15.6127 13.9448 15.7194 13.4031 15.7194C12.8614 15.7194 12.325 15.6127 11.8246 15.4054C11.3241 15.1981 10.8694 14.8943 10.4863 14.5112",
      stroke: "#747C90",
      "stroke-width": "2.31",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.5784 19.253L10.674 20.1573C10.2911 20.5407 9.8363 20.8448 9.33576 21.0523C8.83521 21.2599 8.29868 21.3668 7.75682 21.3669C7.21496 21.367 6.67838 21.2604 6.17773 21.0531C5.67709 20.8458 5.2222 20.5418 4.83904 20.1587C4.45589 19.7755 4.15198 19.3206 3.94467 18.82C3.73737 18.3194 3.63073 17.7828 3.63086 17.2409C3.63099 16.6991 3.73787 16.1625 3.94541 15.662C4.15295 15.1614 4.45707 14.7067 4.8404 14.3237L7.67955 11.4846C8.06259 11.1015 8.51733 10.7977 9.0178 10.5904C9.51827 10.3831 10.0547 10.2764 10.5964 10.2764C11.1381 10.2764 11.6745 10.3831 12.1749 10.5904C12.6754 10.7977 13.1301 11.1015 13.5132 11.4846",
      stroke: "#747C90",
      "stroke-width": "2.31",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }